/** Merchant estimates: Seoul order day, Mon–Fri arithmetic. No holiday calendar. */
export function seoulDay(now = new Date()) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {timeZone:'Asia/Seoul',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now).map(p => [p.type,p.value]));
  return `${parts.year}-${parts.month}-${parts.day}`;
}
export function addBusinessDays(day, count) {
  const date = new Date(`${day}T00:00:00Z`);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day) || !Number.isFinite(date.getTime()) || date.toISOString().slice(0,10) !== day || !Number.isInteger(count) || count < 0) throw new Error('Invalid estimate date');
  for (let remaining = count; remaining > 0;) {
    date.setUTCDate(date.getUTCDate() + 1);
    if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) remaining--;
  }
  return date.toISOString().slice(0,10);
}
export function estimateDates(day, country, options = {}) {
  const min = Math.max(0, Number(options.min ?? 2));
  const max = Math.max(min, Number(options.max ?? 3));
  const transit = Number(country === 'JP' || country === 'TW' ? options.near ?? 3 : options.other ?? 5);
  const start = addBusinessDays(day,min), end = addBusinessDays(day,max);
  return {order:day,dispatch:[start,end],arrival:[addBusinessDays(start,transit),addBusinessDays(end,transit)]};
}
function mountDates() {
  const day = seoulDay();
  const formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {month:'short',day:'numeric',timeZone:'UTC'});
  const format = value => formatter.format(new Date(`${value}T00:00:00Z`));
  const range = values => values[0] === values[1] ? format(values[0]) : `${format(values[0])} – ${format(values[1])}`;
  for (const element of document.querySelectorAll('[data-hv-shipping-dates]')) {
    const {country,dispatchMin,dispatchMax,transitNear,transitOther} = element.dataset;
    const options = {min:dispatchMin,max:dispatchMax,near:transitNear,other:transitOther};
    try {
      const dates = estimateDates(day,country,options);
      element.querySelector('[data-shipping-order]').textContent = `${element.dataset.labelToday} · ${format(day)}`;
      const dispatch = element.querySelector('[data-shipping-dispatch]');
      const arrival = element.querySelector('[data-shipping-arrival]');
      if (element.hasAttribute('data-explicit-dispatch')) {
        const explicit = element.dataset.explicitDispatch;
        // Existing ship-date contract is “ships from”, never a guaranteed dispatch deadline.
        if (explicit && explicit >= day) {
          const earliest = explicit > dates.dispatch[0] ? explicit : dates.dispatch[0];
          const transit = country === 'JP' || country === 'TW' ? Number(transitNear) : Number(transitOther);
          dispatch.textContent = element.dataset.labelFrom.replace('__date__', format(earliest));
          arrival.textContent = element.dataset.labelFrom.replace('__date__', format(addBusinessDays(earliest,transit)));
        } else {
          dispatch.textContent = element.dataset.labelConfirming;
          arrival.textContent = element.dataset.labelAfterConfirmed;
        }
      } else {
        dispatch.textContent = range(dates.dispatch);
        arrival.textContent = range(dates.arrival);
      }
    } catch { /* Preserve honest server-rendered policy text if the estimate cannot be calculated. */ }
  }
}
if (typeof document !== 'undefined') {
  mountDates();
  document.addEventListener('shopify:section:load',mountDates);
  window.addEventListener('pageshow',mountDates);
  // Native section morphs can replace the estimate markup without executing its script again.
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node instanceof Element &&
      (node.matches('[data-hv-shipping-dates]') || node.querySelector('[data-hv-shipping-dates]') || record.target.closest?.('[data-hv-shipping-dates]'))))) mountDates();
  }).observe(document.documentElement,{childList:true,subtree:true});
}
